export default __webpack_public_path__ + "static/media/customs.b9f4cc76.svg";